// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "b84e479006e9295967ee" + ".min.css";
};